<body>
  <div class="grid-overlay">
    <app-page-header>
      <button class="header-action-btn" (click)="goToPortals()">{{ 'updatePortalTemplates.navigation.back' | translate }}</button>
    </app-page-header>
    <div class="create-portal">
      <div class="second-headboard">
        <h1>{{ 'updatePortalTemplates.title' | translate }}</h1>
        <!-- <img src="../../../assets/icons/2341.png" alt="logo de Billcentrix"> -->
        <div class="linked-icons" >
          <button class="active" >{{ 'updatePortalTemplates.navigation.template' | translate }}</button>
          <button   (click)="goToFeatures()">{{ 'updatePortalTemplates.navigation.customization' | translate }}</button>
          @if (!showPaymentButton) {
            <button (click)="goToPortals()">{{ 'updatePortalTemplates.navigation.save' | translate }}</button>
          }
          @if (showPaymentButton) {
            <button >{{ 'updatePortalTemplates.navigation.activatePortal' | translate }}</button>
          }
          <!-- <img src="../../assets/icons/1_cuenta_off.png" alt="Paso 1: Cuenta" (click)="goToEdit()" >
          <img src="../../assets/icons/2_portales_on.png" alt="Paso 2: Portal" >
          <img src="../../assets/icons/3_personalizar_off.png" alt="Paso 3: Personalizar" (click)="goToFeatures()">
          <img src="../../assets/icons/4_planes_off.png" alt="Paso 4: Planes" (click)="goToPlans()"> -->
        </div>
      </div>
      <div class="portal-info">
        <h1>{{ 'updatePortalTemplates.subtitle' | translate }}</h1>
        <p>{{ 'portal.canChangeColors' | translate }}</p>
        <div class="grid">
          <div class="essential template-item" [class.selected]="checked === 1" (click)="selectTemplate(1)">
            <h1>{{ 'updatePortalTemplates.templates.basic.title' | translate }}</h1>
            <p>{{ 'updatePortalTemplates.templates.basic.description' | translate }}</p>
            <img src="../../../assets/images/portal-basico.png" alt="vista previa del portal basico">
            <div class="preview">
              <div class="preview-text">
                <a [routerLink]="'/basic'" target="_blank" >   <img src="../../../assets/icons/ver.png" alt="vista previa"></a>
                <p>{{ 'updatePortalTemplates.templates.basic.preview' | translate }}</p>
                <!-- <p class="text-right">Vista previa</p> -->
              </div>
              <div class="round-checkbox">
                <input type="checkbox" id="checkboxBasic" name="checkboxBasic"
                  (change)="selectTemplate(1); handleCheckboxChange('basic')"
                  [checked]="checkboxBasicValue" [value]="1"
                  [(ngModel)]="checkboxBasicValue">
                </div>
              </div>
            </div>
            <div class="line">
              <div class="practical template-item" [class.selected]="checked === 2" (click)="selectTemplate(2)">
                <h1>{{ 'updatePortalTemplates.templates.practical.title' | translate }}</h1>
                <p>{{ 'updatePortalTemplates.templates.practical.description' | translate }}</p>
                <img src="../../../assets/images/portal-practico.png" alt="vista previa del portal practico">
                <div class="preview">
                  <div class="preview-text">
                    <a [routerLink]="'/practic'" target="_blank" >   <img src="../../../assets/icons/ver.png" alt="vista previa"></a>
                    <p>{{ 'updatePortalTemplates.templates.practical.preview' | translate }}</p>
                    <!-- <p class="text-right">Vista previa</p> -->
                  </div>
                  <div class="round-checkbox">
                    <input type="checkbox" id="checkboxPractical" name="checkboxPractical"
                      (change)="selectTemplate(2); handleCheckboxChange('practical')"
                      [checked]="checkboxPracticalValue" [value]="2"
                      [(ngModel)]="checkboxPracticalValue">
                    </div>
                  </div>
                </div>
              </div>
              <div class="contemporary template-item" [class.selected]="checked === 3" (click)="selectTemplate(3)">
                <h1>{{ 'updatePortalTemplates.templates.contemporary.title' | translate }}</h1>
                <p>{{ 'updatePortalTemplates.templates.contemporary.description' | translate }}</p>
                <img src="../../../assets/images/portal-contempo.png" alt="vista previa del portal contempo">
                <div class="preview">
                  <div class="preview-text">
                    <a [routerLink]="'/contempo'" target="_blank" > <img src="../../../assets/icons/ver.png" alt="vista previa"></a>
                    <p>{{ 'updatePortalTemplates.templates.contemporary.preview' | translate }}</p>
                    <!-- <p class="text-right">Vista previa</p> -->
                  </div>
                  <div class="round-checkbox">
                    <input type="checkbox" id="checkboxContempo" name="checkboxContempo"
                      (change)="selectTemplate(3); handleCheckboxChange('contempo')"
                      [checked]="checkboxContempoValue" [value]="3"
                      [(ngModel)]="checkboxContempoValue">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="options-buttons">
            <button class="back-btn" (click)="goToPortals()">{{ 'updatePortalTemplates.templates.basic.mySubscriptions' | translate }}</button>
            <button class="continue-btn" (click)="saveTemplate()">{{ 'updatePortalTemplates.save' | translate }}</button>
          </div>
        </div>
      </body>
